import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { CerereTypeService } from '../cerere-type.service';
import {
	IRequestType,
	IRequestTypeForm,
	IRequestTypeUpdatePayload,
} from '../cerere-type.interface';

import { helper } from 'src/environments/helper';

import { Observable, Subject, finalize, map } from 'rxjs';
import { UserOrganigramaSearchPayload } from 'src/app/interfaces/common.interface';
import { Generic } from 'src/app/interfaces/generic.interface';
import { CommonService } from 'src/app/services/common.service';
import { CererePriorityService } from 'src/app/platform/nomenclatoare/cerere-priority/cerere-priority.service';
import { StatusService } from 'src/app/platform/nomenclatoare/status-cerere/status.service';
import { RegistreService } from '../../registre/registre.service';

@Component({
	selector: 'app-cerere-request-type',
	templateUrl: './edit-cerere-type.component.html',
	styleUrls: ['./edit-cerere-type.component.scss'],
})
export class EditCerereTypeComponent implements OnInit {
	// general error
	errorTitle: string = environment.config.customNotifications.headers.error;
	errorIcon: string = environment.config.customNotifications.icons.error;
	errorType: string = environment.config.customNotifications.icons.error;
	token!: string;
	isLoading = false;
	helper = helper;

	form: FormGroup = new FormGroup({
		name: new FormControl(this.data.name, [Validators.required]),
		slug: new FormControl(this.data.slug, [Validators.required]),
		directie_id: new FormControl(this.data.directie_id, [Validators.required]),
		compartiment_id: new FormControl(this.data.compartiment_id, []),
		user_id: new FormControl(this.data.user_id, []),
		priority_id: new FormControl(this.data.priority_id, [Validators.required]),
		status_id: new FormControl(this.data.status_id, [Validators.required]),
		observations: new FormControl(this.data.observations, []),
		indoc_name: new FormControl(this.data.indoc_name, [Validators.required]),
		indoc_id: new FormControl(this.data.indoc_id, [Validators.required]),
	});

	directiiActive$!: Observable<Generic[]>;
	compartimenteActive$!: Observable<Generic[]>;
	usersActive$!: Observable<Generic[]>;
	statusesActive$!: Observable<Generic[]>;
	prioritiesActive$!: Observable<Generic[]>;

	parameters: { key: string; value: string }[] = [
		{ key: '--Alegeți--', value: '-1' },
		{ key: 'Da', value: '1' },
		{ key: 'Nu', value: '0' },
	];

	defaultParameter: { name: string; id: string } = {
		name: '--Alegeți--',
		id: '-1',
	};

	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: IRequestType,
		private dialogRef: MatDialogRef<EditCerereTypeComponent>,
		private requestTypesService: CerereTypeService,
		private notificationService: NotificationService,
		private authService: AuthService,
		private commonService: CommonService,
		private cererePriorityService: CererePriorityService,
		private statusService: StatusService
	) {
		this.processToken();
	}

	ngOnInit(): void {
		this.loadDirectiiActive();
		this.loadStatususesActive();
		this.loadPrioritiesActive();

		if (this.data.compartiment_id) {
			this.loadCompartimenteActive(this.data.directie_id);
		}

		if (this.data.user_id) {
			this.loadUsersActive();
		}

		console.log(this.data);
	}

	closeDialog() {
		this.dialogRef?.close({
			success: false,
		});
	}

	processToken() {
		const tokenObj = this.authService.returnTokenUser();
		tokenObj.then((token) => {
			this.token = token;
			this.requestTypesService.setToken(token);
		});
	}

	submitForm() {
		this.isLoading = true;

		const {
			name,
			slug,
			priority_id,
			status_id,
			directie_id,
			compartiment_id,
			user_id,
			observations,
			indoc_id,
			indoc_name
		} = this.form.value as IRequestTypeForm;
		const updateRequestType: IRequestTypeUpdatePayload = {
			id: this.data.id,
			name,
			slug,
			priority_id,
			status_id,
			directie_id,
			compartiment_id,
			user_id,
			observations,
			indoc_id,
			indoc_name
		};

		this.requestTypesService
			.updateRequestType(updateRequestType)
			.pipe(finalize(() => (this.isLoading = false)))
			.subscribe({
				next: () => {
					this.dialogRef.close({ success: true });
				},
				error: (err) => {
					let errorMessage =
						environment.config.customNotifications.generalMessages.error;
					this.notificationService.warningSwal(
						this.errorTitle,
						errorMessage,
						this.errorIcon
					);
				},
			});
	}

	onHttpError(res: any) {
		if (res.errors && res.errors.message && res.errors.message.length > 0) {
			res.errors.message.forEach((msg: string) => {
				this.notificationService.warningSwal(
					this.errorTitle,
					msg,
					this.errorIcon
				);
			});
		} else {
			let msg;
			try {
				// try to catch the message from server
				msg = res.error.errors.message[0];
			} catch (error) {
				// controll output message
				msg = helper.dialogConfig.generalMessages.error;
			}
			this.notificationService.warningSwal(
				this.errorTitle,
				msg,
				this.errorIcon
			);
		}
	}

	loadDirectiiActive() {
		this.isLoading = true;
		this.directiiActive$ = this.commonService.getDirectiiActive().pipe(
			map((results: any) => [this.defaultParameter, ...results]),
			finalize(() => (this.isLoading = false))
		);
	}

	onDirectieChange(directieId: number): void {
		if (directieId) {
			this.loadCompartimenteActive(directieId);
			this.loadUsersActive();
		} else {
			this.compartimenteActive$ = new Observable<Generic[]>((observer) => {
				observer.next([{ name: '--Alegeți--', id: -1 }]);
				observer.complete();
			});

			console.log(this.compartimenteActive$, 'check here pls');
		}
	}

	loadCompartimenteActive(directieId?: number) {
		this.isLoading = true;
		let compartimenteObservable$ = directieId
			? this.commonService.getCompartimenteByDirectieId(directieId)
			: this.commonService.getCompartimenteActive();

		this.compartimenteActive$ = compartimenteObservable$.pipe(
			map((results: any) => [this.defaultParameter, ...results]),
			finalize(() => {
				this.isLoading = false;
			})
		);
	}

	onDirectieCompartimentChange(compartimentId: number): void {
		this.loadUsersActive();
	}

	loadStatususesActive() {
		this.isLoading = true;
		this.statusesActive$ = this.statusService.getCerereStatuses().pipe(
			map((results: any) => [this.defaultParameter, ...results]),
			finalize(() => (this.isLoading = false))
		);
	}

	loadPrioritiesActive() {
		this.isLoading = true;
		this.prioritiesActive$ = this.cererePriorityService
			.getCererePriorities()
			.pipe(
				map((results: any) => [this.defaultParameter, ...results]),
				finalize(() => (this.isLoading = false))
			);
	}

	loadUsersActive() {
		this.isLoading = true;
		this.usersActive$ = this.commonService
			.getUsersByOrganigrama(this.form.value)
			.pipe(
				map((results: any) => [this.defaultParameter, ...results]),
				finalize(() => (this.isLoading = false))
			);
	}
}
